import { Component, Input, OnInit } from '@angular/core';
import { IProjectStatusData, ICustomColorScheme } from '../../../../models/project/project-dashboard.model';
@Component({
  selector: 'app-project-status',
  templateUrl: './project-status.component.html',
  styleUrls: ['./project-status.component.scss'],
  standalone: false,
})
export class ProjectStatusComponent implements OnInit {
  @Input() projectStatusData!: IProjectStatusData;
  @Input() colorTheme!: ICustomColorScheme[];

  constructor() {}

  ngOnInit() {}
}
